export default "https://stage-platform-api.carrotenglish.net"
